var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2072 0.313626L18.1299 3.23642C18.3308 3.43849 18.4436 3.71185 18.4436 3.99678C18.4436 4.28171 18.3308 4.55506 18.1299 4.75713L4.44351 18.4436H1.07852C0.79248 18.4436 0.518153 18.3299 0.315892 18.1277C0.11363 17.9254 0 17.6511 0 17.365V14.0001L13.6864 0.313626C13.8885 0.11275 14.1619 0 14.4468 0C14.7317 0 15.0051 0.11275 15.2072 0.313626ZM14.4522 2.88051L2.22175 15.1109V16.1895H3.30028L15.5631 3.99138L14.4522 2.88051Z",
    fill: "#12162E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8619 17.0307L20.7834 18.1092C20.6826 18.2092 20.5631 18.2883 20.4317 18.3419C20.3003 18.3956 20.1595 18.4228 20.0176 18.422H9.35104C9.25753 18.4215 9.16625 18.3934 9.08866 18.3413C9.01106 18.2891 8.95061 18.2151 8.91489 18.1287C8.87918 18.0423 8.86978 17.9473 8.88789 17.8555C8.906 17.7638 8.95081 17.6795 9.01669 17.6131L10.0952 16.5346C10.196 16.4346 10.3155 16.3556 10.4469 16.3019C10.5783 16.2482 10.719 16.221 10.861 16.2218H21.506C21.6013 16.2179 21.6956 16.2428 21.7766 16.2933C21.8576 16.3438 21.9214 16.4175 21.9599 16.5048C21.9983 16.5922 22.0095 16.6891 21.992 16.7829C21.9746 16.8767 21.9292 16.9631 21.8619 17.0307Z",
    fill: "#67AB56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAction);
export default __webpack_public_path__ + "static/media/EditAction.3344b68d164692559f96db9019fad9ee.svg";
export { ForwardRef as ReactComponent };